import React from 'react'
import Image from '../atoms/Image'
import ColorDot from '../atoms/ColorDot'
import { Product } from '../../interfaces/product'
// import Icon from '../atoms/Icon'
// import { handleAddToCart } from '../../helpers/global'
// import { trackAddToCart } from '../../helpers/trackCartActions'

interface ProductProps {
  product: Product
}
// interface QuickAddButtonProps {
//   product: ProductSimple
//   variant: ProductVariant
// }
//
// const QuickAddButton: React.FC<QuickAddButtonProps> = ({ product, variant }) => {
//   const [showSizeSelector, setShowSizeSelector] = useState(false);
//   const sizeSelectorRef = useRef<HTMLDivElement | null>(null);
//
//   const { available } = variant
//   const BISProduct = {
//     id: variant.id,
//     handle: product.handle,
//     available: available,
//     tags: variant.tags,
//     variants: product.variants?.map((variant) => ({
//       id: variant.id,
//       available: variant.available,
//       title: variant.title
//     })),
//   }
//   const renderSizeSelector = () => {
//     console.log(product);
//     const sizeOption = product.optionsWithValues?.find((option) => option.name.toLowerCase() === 'size')
//     if (!sizeOption || !sizeOption.values?.length || !showSizeSelector) return null
//     return (
//       <div
//         className="absolute z-2 bottom-12 left-0 right-0 px-2 transition-transform transform fade-in"
//         ref={sizeSelectorRef}
//       >
//         <div className="bg-black bg-opacity-80 rounded-lg p-2">
//           <p className="body-xs text-grey-5 mb-1">{window.DEPT.Strings.productCard.selectSize}</p>
//           {/*<select*/}
//           {/*  value={variant.options?.find((option) => sizeOption.values?.includes(option)) || ''}*/}
//           {/*  onChange={handleSizeChange}*/}
//           {/*  className="h-8 body-xs text-black bg-grey-5 p-1 pl-3 w-full border border-grey-4 rounded-full shadow-search mb-8 focus:outline-none focus:ring-0"*/}
//           {/*>*/}
//           {/*  {sizeOption.values.map((size) => {*/}
//           {/*    const isAvailable = variants.some((variant) => variant.options.includes(size) && variant.available)*/}
//
//           {/*    return (*/}
//           {/*      <option key={size} value={size}>*/}
//           {/*        {size} {!isAvailable && window.DEPT.Strings.productCard.soldOut}*/}
//           {/*      </option>*/}
//           {/*    )*/}
//           {/*  })}*/}
//           {/*</select>*/}
//           <div className="flex flex-col gap-2.5 md:flex-row md:items-center md:justify-between">
//             <a
//               className="body-xs text-grey-5 underline"
//               href={`${variant.url}#size-guide-pdp`}
//               aria-label={window.DEPT.Strings.productCard.sizeGuide}
//             >
//               {window.DEPT.Strings.productCard.sizeGuide}
//             </a>
//             <button
//               type="button"
//               className={`body-xs flex items-center justify-center rounded-full border md:body-sm ${
//                 variant.available
//                   ? 'cursor-pointer border-grey-5 bg-transparent text-grey-5 hover:bg-grey-5 hover:text-black'
//                   : 'cursor-not-allowed border-disabled bg-disabled text-black'
//               } py-2.5 px-6`}
//               disabled={!variant.available}
//               onClick={() => {
//                 handleAddToCart(
//                   variant.id,
//                   1,
//                   variant.metafields?.relatedVariants
//                 );
//                 trackAddToCart(product,variant);
//                 setTimeout(() => setShowSizeSelector(false), 300);
//               }}
//             >
//               {window.DEPT.Strings.productCard.addToCart}
//             </button>
//           </div>
//         </div>
//       </div>
//     )
//   }
//
//   const handleClick = (e: React.MouseEvent) => {
//     const hasSizeOption = product.optionsWithValues?.some((option) => option.name.toLowerCase() === 'size')
//     if (hasSizeOption) {
//       setShowSizeSelector(true)
//     } else {
//       e.preventDefault()
//       handleAddToCart(variant.id)
//       trackAddToCart(product, variant)
//     }
//   }
//
//   const button= (
//     <>
//       {renderSizeSelector()}
//       <button
//         type="button"
//         className={`${available ? 'bg-green-1 shadow-inner-green' : 'bg-disabled shadow-inner-grey pointer-events-none'} w-7 flex items-center justify-center rounded-full h-7 absolute bottom-0 right-0 m-1 z-30`}
//         onClick={handleClick}
//         data-variant-id={variant.id}
//         aria-label="Add To Cart"
//       >
//         <Icon name="cart" className="text-black pointer-events-none" />
//       </button>
//     </>
//
//   )
//   return available ? (
//     button
//   ) : (
//     <a
//       href="#"
//       className="BIS_trigger flex"
//       data-product-data={`${JSON.stringify(BISProduct)}`}
//       data-variant-id={variant.id}
//       aria-label="Notify Me When Available"
//     >
//       {button}
//     </a>
//   )
// }


const ProductCardQuickAdd: React.FC<ProductProps> = ({ product }) => {
  const { title, handle } = product
  const filteredVariants = product.variants?.filter(variant => {
    const title = variant.title?.toLowerCase()
    if (!title || !title.includes('/')) return true

    // If it contains '/', only keep if it doesn't have 'large' or 'wide'
    return !title.includes('large') && !title.includes('wide')
  })

  return (
    <>
      {filteredVariants?.map((variant) => (
          <div className='' key={variant.id}>
            <div className="relative rounded overflow-hidden aspect-square">
              <div className="absolute z-2 top-0 left-0 right-0 bg-gradient-metal border-b border-grey-2">
                <div className="flex items-center gap-x-1 py-1.5 px-1 md:p-1.5">
                  <ColorDot colorType="red" />
                  <ColorDot colorType="yellow" />
                  <ColorDot colorType="green" />
                </div>
              </div>
              <a href={`/products/${handle}?variant=${variant.id}`} className="absolute inset-0 z-1 bg-white flex mt-4"
                 aria-label={title} key={variant.id}>
                {variant.featured_image?.src && (
                  <Image
                    alt={variant.featured_image.alt}
                    src={variant?.featured_image?.src}
                    srcWidths={{ sm: 640 }}
                    height={800}
                    width={640}
                    wrapperClasses="w-full h-full object-contain"
                    classes="w-full h-full object-contain"
                  />
                )}
              </a>
              {/*<QuickAddButton product={product} variant={variant} />*/}
            </div>
            <div>
              {title && <h3 className="body-md font-bold mt-3 lg:mt-4 truncate">{title}</h3>}
              {variant.title && <p className="body-xs truncate">
                {variant.title.includes('/') ? variant.title.split('/')[0] : variant.title}
              </p>}
            </div>
          </div>
      ))}
    </>
  )
}

export default ProductCardQuickAdd
